import { Popover } from '@transferwise/components';
import { AlertCircle } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatDeliveryEstimation } from '../resources/delivery-estimation-formatter/deliveryEstimationFormatter';
import { getCitationCopy } from '../resources/deliveryEstimationCitationService';

import componentStyles from './DeliveryEstimation.module.less';

const DeliveryEstimation = ({
  styles,
  deliveryEstimation,
  isPartner,
  alias,
  onClickingDeliveryEstimationTooltip,
  isTravelMoney,
}) => {
  const { locale } = useIntl();
  const derivedStyles = { ...componentStyles, ...styles };
  const citationCopy = getCitationCopy(deliveryEstimation, isPartner, alias, locale, isTravelMoney);
  return (
    <div className={derivedStyles['delivery-estimation']} data-testid="delivery-estimation">
      <span className={derivedStyles['delivery-estimation-data']}>
        {formatDeliveryEstimation(deliveryEstimation, { lang: locale })}
      </span>

      <span // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        id="delivery-estimation-tool-tip"
        onClick={onClickingDeliveryEstimationTooltip}
      >
        {citationCopy && (
          <Popover title={citationCopy.title} content={citationCopy.body}>
            <div>
              <AlertCircle
                className={derivedStyles['tw-help-icon']}
                data-testid="help-circle-icon"
                size={16}
              />
            </div>
          </Popover>
        )}
      </span>
    </div>
  );
};

DeliveryEstimation.propTypes = {
  styles: PropTypes.shape({
    speed: PropTypes.string,
  }),
  deliveryEstimation: PropTypes.shape({
    duration: PropTypes.shape({
      min: PropTypes.string,
      max: PropTypes.string,
    }),
    providerGivesEstimate: PropTypes.bool,
  }).isRequired,
  isPartner: PropTypes.bool.isRequired,
  alias: PropTypes.string.isRequired,
  onClickingDeliveryEstimationTooltip: PropTypes.func.isRequired,
  isTravelMoney: PropTypes.bool,
};

DeliveryEstimation.defaultProps = {
  styles: componentStyles,
  isTravelMoney: false,
};

export default DeliveryEstimation;
